import { createContext } from 'react';

export interface ImpersonationSessionState {
  sessionId: number;
  impersonationToken: string;
  targetTenantId: number;
  targetTenantName: string;
  targetUserName: string;
  expiresAt: string;
}

export interface ImpersonationContextValue {
  session: ImpersonationSessionState | null;
  active: boolean;
  startSession: (session: ImpersonationSessionState) => void;
  endSession: () => Promise<void>;
}

export const ImpersonationContext = createContext<ImpersonationContextValue>({
  session: null,
  active: false,
  startSession: () => {},
  endSession: async () => {},
});
